var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueFeedback',{attrs:{"type":"empty-state"}},[_c('h3',{attrs:{"slot":"feedback-title"},slot:"feedback-title"},[_vm._v(_vm._s(_vm.t('stock-no-event')))]),_c('p',{attrs:{"slot":"feedback-content"},slot:"feedback-content"},[_vm._v(_vm._s(_vm.t('stock-no-event-msg')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }